<script setup>
import { watch } from 'vue'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { Label, Input, Select } from '@components'
const props = defineProps({
    item: {
        type: Object,
    }
})

watch(() => props.item.value, () => {
    console.log(props.item.value)
    let values = {
        ...$appointments.appointment.custom_fields,
        [props.item.id]: props.item.value
    }

    $appointments.setAppointment('custom_fields', values)
})
</script>

<template>
    <div>
        <Label>{{ props.item.label }}<span v-if="props.item.required" class="text-[#D92D20]">*</span></Label>
        <Select v-if="props.item.type === 'select'" v-model="props.item.value" :options="props.item.options" placeholder="Select option" class="mt-1.5"></Select>
        <Input v-if="props.item.type === 'input'" v-model="props.item.value" :placeholder="props.item.placeholder" class="mt-1.5" inputContainerClass="p-[8px_12px]"></Input>
    </div>
</template>

<style>

</style>